export enum EChatType {
  ONE_TO_ONE = 'ONE_TO_ONE',
  GROUP = 'GROUP',
}
